import {
    ADD_SMS_TEMPLATE,
    GET_SMS_TEMPLATE,
    EDIT_SMS_TEMPLATE,
    ALL_SMS_TEMPLATE
  } from "./actionTypes"
  
  export const addSMSTemplate = (template,history) => {
    return {
      type: ADD_SMS_TEMPLATE,
      payload: { template,history},
    }
  }

  export const getSMSTemplate = (data) => {
    return {
      type: GET_SMS_TEMPLATE,
      payload: { data },
    }
  }

  export const allSMSTemplate = template => {
    return {
      type: ALL_SMS_TEMPLATE,
      payload: template,
    }
  }

  export const editSMSTemplate = (template,history) => {
    return {
      type: EDIT_SMS_TEMPLATE,
      payload:{template,history},
    }
  }